import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const SUBMIT_ANSWERS_REQUEST = 'SUBMIT_ANSWERS_REQUEST';
export const SUBMIT_ANSWERS_SUCCESS = 'SUBMIT_ANSWERS_SUCCESS';
export const SUBMIT_ANSWERS_FAILURE = 'SUBMIT_ANSWERS_FAILURE';

function requestSubmitAnswers() {
  return {
    type: SUBMIT_ANSWERS_REQUEST,
    isSubmittingAnswers: true,
    redirectUrl: ''
  };
}

function receiveSubmitAnswers(formType, id) {
  return {
    type: SUBMIT_ANSWERS_SUCCESS,
    isSubmittingAnswers: false,
    redirectUrl: `/forms/${ formType }/${ id }`
  };
}

function rejectSubmitAnswers(error) {
  return {
    type: SUBMIT_ANSWERS_FAILURE,
    isSubmittingAnswers: false,
    redirectUrl: ''
  };
}

export function submitAnswers(data) {
  return (dispatch) => {
    dispatch(requestSubmitAnswers());

    const promise = () => ApiService
      .submitAnswers(data)
      .then((response) => {
        dispatch(receiveSubmitAnswers(data.formType, response.data));
      }).catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSubmitAnswers, true));
        }
      });
    return promise();
  };
}
